import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cx } from "../cx";

/** A square button around one icon; `label` is required because the icon says nothing. */
export function IconButton({
  label,
  icon,
  variant = "quiet",
  size = "md",
  className = "",
  type = "button",
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  icon: ReactNode;
  variant?: "quiet" | "secondary";
  size?: "sm" | "md";
}) {
  return (
    <button
      {...rest}
      type={type}
      aria-label={label}
      title={label}
      data-component="IconButton"
      className={cx(
        "inline-flex shrink-0 items-center justify-center rounded-sm border disabled:cursor-not-allowed disabled:opacity-60",
        size === "sm" ? "h-control-sm w-control-sm" : "h-control w-control",
        variant === "quiet"
          ? "border-transparent text-ink-2 hover:bg-sunken hover:text-ink"
          : "border-line bg-surface text-ink hover:border-line-strong",
        className,
      )}
    >
      {icon}
    </button>
  );
}
